import React, { useEffect } from 'react'
import { Button, Card, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useCreatePortalSessionMutation } from '../../slices/stripeApiSlice';
import { useGetProductsQuery } from '../../slices/productsApiSlice';
import Loader from '../../components/Loader';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useQueryParams from '../../hooks/useQueryParams';
import SearchResults from '../../components/SearchResults';
import { Link } from 'react-router-dom';

const SubscriptionStatusScreen = () => {
    const navigate = useNavigate();

    const { userInfo } = useSelector((state) => state.auth);
    const [createPortalSession, { isLoading: loadingPortalSession }] = useCreatePortalSessionMutation();

    const [query, updateQueryParams] = useQueryParams();

    const pageNumber = parseInt(query.page, 10) || 1;
    const maxPrice = userInfo.subscription.itemPriceLimit ? parseInt(userInfo.subscription.itemPriceLimit, 10) : '';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pageNumber, query]);

    const { data: productsData, isLoading: productsLoading, error: productsError } = useGetProductsQuery({
        pageNumber,
        maxPrice,
    });

    const handlePortalSession = async () => {
        if (userInfo.subscription?.usedItems !== 0) {
            toast.error('プラン変更の前に、レンタル中の商品を返却する必要があります');
            return;
        }
        try {
            const { url } = await createPortalSession().unwrap();
            window.location.href = url;
        } catch (err) {
            toast.error('ポータルセッションの作成に失敗しました');
        }
    };
    const visitSubscriptionPage = () => {
        navigate('/subscriptions');
    }

    return (
        <Container>
            <Card className='text-center'>
                <Card.Header as="h2">サブスクリプション</Card.Header>
                <Card.Body>
                    {userInfo.subscription ? (
                        <div>
                            <p><strong>プラン: </strong> {userInfo.subscription.name}</p>
                            <p><strong>アイテムの上限料金: </strong> ¥{userInfo.subscription.itemPriceLimit}</p>
                            <p><strong>借りている着数: </strong> {userInfo.subscription.usedItems} / {userInfo.subscription.maxItems}</p>
                            <Button
                                variant="primary"
                                className="my-2"
                                onClick={handlePortalSession}
                                disabled={loadingPortalSession || userInfo.subscription.usedItems !== 0}
                            >
                                {loadingPortalSession ? <Loader /> : 'プランを変更する'}
                            </Button>
                            {userInfo.subscription.usedItems !== 0 && (
                                <p><small>※ プラン変更の前に、レンタル中の商品を返却する必要があります</small></p>
                            )}
                        </div>
                    ) : (
                        <div>
                            <p>
                                <strong>サブスクに加入して、もっとお得に古着を楽しみましょう！</strong>
                            </p>
                            <Button
                                variant="primary"
                                className="my-2"
                                onClick={visitSubscriptionPage}
                            >
                                プランを見る
                            </Button>
                        </div>
                        
                    )}
                </Card.Body>
            </Card>
            <Card className='mt-3'>
                <Card.Header className='text-center'>
                    {userInfo?.subscription?.name}でレンタルできる商品
                    <small>
                        <Link to="/search" className="link-secondary text-decoration-underline ms-2">もっと見る</Link>
                    </small>
                </Card.Header>
                <Card.Body>
                    {productsLoading ? (
                        <p>Loading...</p>
                    ) : productsError ? (
                        <p>Error: {productsError.message}</p>
                    ) : (
                        <SearchResults
                            productsData={productsData}
                            keyword={''}
                        />
                    )}
                </Card.Body>
            </Card>
        </Container>
    )
}

export default SubscriptionStatusScreen